import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-behavior',
  templateUrl: './system-behavior.component.html',
  styleUrls: ['./system-behavior.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemBehaviorComponent {
  @Input() systemCharacteristics: string;
}
